import type {
  EmailMessage,
  EmailProvider,
  EmailSendResult,
} from '@/modules/communications/types/email.types';

export class ConsoleEmailProvider implements EmailProvider {
  readonly id = 'console';
  readonly sandbox = true;

  async send(message: EmailMessage): Promise<EmailSendResult> {
    const to = Array.isArray(message.to) ? message.to.join(', ') : message.to;
    if (import.meta.env.DEV) {
      console.info('[erp:email:console]', { to, subject: message.subject });
    }
    return {
      ok: true,
      providerId: this.id,
      messageId: `console-${Date.now()}`,
      sandbox: true,
    };
  }
}
